export const updateErrorArr = (indx, errorMsg, errorArr) => {
    errorArr[indx].error = true;
    errorArr[indx].message = errorMsg;
    errorArr[indx].textType = "text-danger";
    
}
export default updateErrorArr;